import { useCallback, useRef, type ReactNode } from 'react';
import { ScrollToEndContext } from '.';

interface ScrollToEndProviderProps {
  children: ReactNode;
}

export const ScrollToEndProvider = ({ children }: ScrollToEndProviderProps) => {
  const endRef = useRef<HTMLDivElement>(null);

  const scrollToEnd = useCallback(() => {
    setTimeout(() => {
      endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }, 150);
  }, []);

  return (
    <ScrollToEndContext.Provider value={{ scrollToEnd, endRef }}>
      {children}
    </ScrollToEndContext.Provider>
  );
};
